export { CELL_TYPE, HandsontableCellType } from "./handsontableType.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/cellTypes/handsontableType/index.mjs
// module id = 1105
// module chunks = 1